import { render, staticRenderFns } from "./ShareWidget.vue?vue&type=template&id=878907dc&"
import script from "./ShareWidget.vue?vue&type=script&lang=js&"
export * from "./ShareWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports